import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { ProviderData } from '@/common/types';
import { Image } from 'react-bootstrap';
import Avatar from '@/common/components/Avatar';
import BioText from '@/common/components/BioText';

const ProviderShowPage: React.FC = () => {
  const provider = useLoaderData() as ProviderData;

  return (
    <div className="py-5 px-4 px-md-5" style={{ maxWidth: 900 }}>
      <div className="mb-4 text-start">
        <a href={`/portal/providers/${provider.id}/edit`}>
          <button className="btn btn-outline-primary">Edit Provider</button>
        </a>
      </div>

      <h2 className="mb-4">
        {provider.firstName} {provider.lastName}
      </h2>
      <div className="row">
        <div className="col-md-5">
          {provider.photoUrl && (
            <div className="mb-4">
              <h5 className="mb-2">Profile Photo</h5>
              <Image
                src={provider.photoUrl}
                className="rounded-5 shadow-sm d-block"
                style={{ width: '100%', maxWidth: '300px', height: 'auto' }}
              />
            </div>
          )}
        </div>

        <div className="col-md-7">
          <div className="mb-4 d-flex align-items-center gap-3">
            <h5 className="mb-0">Avatar</h5>
            {provider.avatarUrl && (
              <Avatar src={provider.avatarUrl} alt="Avatar" size={100} />
            )}
          </div>

          {provider.ehrUuid && (
            <div className="mb-4">
              <h5 className="mb-1">Healthie Provider ID</h5>
              <div className="text-dark">{provider.ehrUuid}</div>
            </div>
          )}

          <div className="mb-3">
            <h5>Credentials</h5>
            <div>
              {provider.credentials?.length > 0
                ? provider.credentials.map((cred) => (
                    <span key={cred.id} className="badge bg-primary me-2 mb-2">
                      {cred.title}
                    </span>
                  ))
                : null}
            </div>
          </div>

          <div className="mb-3">
            <h5>Licensed States</h5>
            <div>
              {provider.states?.length > 0
                ? provider.states.map((state) => (
                    <span key={state.id} className="badge bg-primary me-2 mb-2">
                      {state.displayName}
                    </span>
                  ))
                : null}
            </div>
          </div>

          <div className="mb-3">
            <h5>Accepted Insurance</h5>
            <div>
              {provider.insuranceCompanies?.length > 0
                ? provider.insuranceCompanies.map((ins) => (
                    <span key={ins.id} className="badge bg-primary me-2 mb-2">
                      {ins.name}
                    </span>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>

      {provider.bio && (
        <div className="mt-4">
          <h5>Bio</h5>
          <div className="mt-2">
            <BioText text={provider.bio} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProviderShowPage;
